<template>
    <a-modal
        id="integrate-story-list-with-ig-modal"
        :title="$t('chatbotv2.integrateStoryWithInstagram')"
        wrapClassName="vertical-center-modal"
        :visible="modalVisible"
        @visibleChange="(isVisible) => $emit('modal-visible2', isVisible)"
        :footer="null"
        @cancel="handleCancel()"
    >
        <a-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
            <a-form-item
                :label="$t('chatbotv2.selectIntegratingStory')"
                :fieldDecoratorOptions="{
                    rules: [{ required: true, message: $t('chatbotv2.integrateStoryWithSupsisWidget') }],
                }"
            >
                <a-select v-model="selectedStory" @change="handleChange">
                    <a-select-option :key="story.id" v-for="story in stories" :value="story.id"
                        >{{ story.title }}
                    </a-select-option>
                </a-select>
            </a-form-item>
        </a-form>
        <div class="d-flex flex-row justify-content-between">
            <div class="d-flex flex-row justify-content-start">
                <a-button type="danger" v-if="!!selectedStory" @click="revokeDefault()">
                    <span> <a-icon type="api" class="px-1" /></span>{{ $t("chatbotv2.uninstall") }}
                </a-button>
            </div>
            <div class="d-flex flex-row justify-content-end">
                <a-button class="mr-1 ant-btn-primary" @click="handleOk()" :disabled="!isChangedStory">
                    {{ $t("chatbotv2.install") }}
                </a-button>
                <a-button class="ml-1" @click="handleCancel()">{{ $t("message.cancel") }} </a-button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "SelectStoryIntegratingWithInstagram",
    props: {
        modalVisible: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    data() {
        return {
            selectedStory: undefined,
            isChangedStory: false,
        };
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
            makeDefaultStory: "CB/makeDefaultStory",
            revokeDefaultStory: "CB/revokeDefaultStory",
        }),
        handleSave() {
            if (!this.selectedStory) return;
            this.makeDefaultStory({ selectedStory: this.selectedStory, integrationApp: "instagram" });
            this.$emit("modal-visible", false);
            this.isChangedStory = false;
        },
        reset() {
            this.selectedStory = null;
            this.isChangedStory = false;
        },
        handleOk() {
            this.handleSave();
        },
        handleChange() {
            this.isChangedStory = true;
        },
        handleCancel() {
            this.$emit("modal-visible", false);
            if (this.isChangedStory === true) {
                this.selectedStory = _.get(
                    this.stories.find((x) => _.get(x, "integrations.instagram")),
                    "id"
                );
                this.isChangedStory = false;
            }
        },
        revokeDefault() {
            this.revokeDefaultStory({ integrationApp: "instagram" });
            this.$emit("modal-visible", false);
            this.reset();
        },
    },
    mounted() {},
    watch: {
        stories: {
            handler(newVal) {
                if (newVal)
                    this.selectedStory = _.get(
                        this.stories.find((x) => _.get(x, "integrations.instagram")),
                        "id"
                    );
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.vertical-center-modal {
    text-align: center;
    white-space: nowrap;
}

.vertical-center-modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    width: 0;
}

.vertical-center-modal .ant-modal {
    display: inline-block;
    vertical-align: middle;
    top: 0;
    text-align: left;
}
</style>
